import React, { forwardRef } from "react";

// Unified player for Vimeo, YouTube, and direct MP4 sources
const VideoPlayer = forwardRef(function VideoPlayer(
  {
    src,
    title,
    className,
    poster,
    autoPlay,
    loop,
    muted,
    controls = true,
    playsInline = true,
    allow,
    allowFullScreen = true,
    frameBorder = 0,
    ...rest
  },
  ref
) {
  if (!src) return null;

  const videoClass = className || "learn-video";
  const isVimeo = src.includes("vimeo.com");
  const isYouTube = src.includes("youtube.com") || src.includes("youtu.be");
  const isIframe = isVimeo || isYouTube;
  const iframeAllow =
    allow || "autoplay; fullscreen; picture-in-picture; encrypted-media; accelerometer; gyroscope";

  if (isIframe) {
    return (
      <iframe
        ref={ref}
        className={videoClass}
        src={src}
        title={title || "Video"}
        allow={iframeAllow}
        allowFullScreen={allowFullScreen}
        frameBorder={frameBorder}
        loading="lazy"
        {...rest}
      />
    );
  }

  return (
    <video
      ref={ref}
      className={videoClass}
      poster={poster}
      autoPlay={autoPlay}
      loop={loop}
      muted={muted}
      controls={controls}
      preload="metadata"
      playsInline={playsInline}
      {...rest}
    >
      <source src={src} type="video/mp4" />
      Your browser does not support the video tag.
    </video>
  );
});

export default VideoPlayer;
